export function isVisible(el) {
  return window.getComputedStyle(el).display !== 'none';
}


//////////////////
// WEBPACK FOOTER
// ./~/tiny-slider/src/helpers/isVisible.js
// module id = 850
// module chunks = 2